import { JSX } from "react";

export const Clock = (): JSX.Element => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_16580_2361"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
            >
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_16580_2361)">
                <path
                    d="M8.99922 16.5C8.06172 16.5 7.18359 16.3218 6.36484 15.9656C5.54609 15.6093 4.83359 15.1281 4.22734 14.5218C3.62109 13.9156 3.13984 13.2031 2.78359 12.3843C2.42734 11.5656 2.24922 10.6875 2.24922 9.74995C2.24922 8.81245 2.42734 7.93433 2.78359 7.11558C3.13984 6.29683 3.62109 5.58433 4.22734 4.97808C4.83359 4.37183 5.54609 3.89058 6.36484 3.53433C7.18359 3.17808 8.06172 2.99995 8.99922 2.99995C9.93672 2.99995 10.8148 3.17808 11.6336 3.53433C12.4523 3.89058 13.1648 4.37183 13.7711 4.97808C14.3773 5.58433 14.8586 6.29683 15.2148 7.11558C15.5711 7.93433 15.7492 8.81245 15.7492 9.74995C15.7492 10.6875 15.5711 11.5656 15.2148 12.3843C14.8586 13.2031 14.3773 13.9156 13.7711 14.5218C13.1648 15.1281 12.4523 15.6093 11.6336 15.9656C10.8148 16.3218 9.93672 16.5 8.99922 16.5ZM11.0992 12.9L12.1492 11.85L9.74922 9.44995V5.99995H8.24922V10.05L11.0992 12.9ZM4.19922 1.76245L5.24922 2.81245L2.06172 5.99995L1.01172 4.94995L4.19922 1.76245ZM13.7992 1.76245L16.9867 4.94995L15.9367 5.99995L12.7492 2.81245L13.7992 1.76245ZM8.99922 15C10.4617 15 11.7023 14.4906 12.7211 13.4718C13.7398 12.4531 14.2492 11.2125 14.2492 9.74995C14.2492 8.28745 13.7398 7.04683 12.7211 6.02808C11.7023 5.00933 10.4617 4.49995 8.99922 4.49995C7.53672 4.49995 6.29609 5.00933 5.27734 6.02808C4.25859 7.04683 3.74922 8.28745 3.74922 9.74995C3.74922 11.2125 4.25859 12.4531 5.27734 13.4718C6.29609 14.4906 7.53672 15 8.99922 15Z"
                    fill="#1D2D58"
                />
            </g>
        </svg>
    );
};
